// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_main__RqlRW {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.styles_title__NK1ji {
  color: #0f2047;
  font-family: "Inter";
  font-weight: 500;
  text-align: center;
  font-size: 1rem;
}

.styles_separador__5sS6U {
  margin-top: 1rem;
  width: 100%;
  max-width: 75vw;
}

.styles_botoes__cKl9H{
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.styles_switch__wvlSc{
  align-items: center;
  display: flex;
  gap: .2rem;
  /* justify-content: space-between; */
}

.styles_botaoTentar__pmwKQ{
  border:1px solid #18316e !important;
  color: #18316e !important;
  margin-right: 1rem !important;
  margin-top: 2rem  !important;
  text-transform: none  !important;
}

.styles_containerBotao__lt20e{
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.styles_botaoProsseguir__mFtn9 {
  align-self: self-end;
  background-color: #18316e !important;
  color: white !important;
  font-family: "Inter"  !important;
  transition: all 0.3s ease  !important;
  text-transform: none  !important;
  font-weight: 300  !important;
  margin-top: 2rem  !important;
}

.styles_botaoFechar__IP9IE {
  align-self: self-start;
  background-color: #fff !important;
  border: 1px solid #18316e;
  color: #18316e !important;
  font-family: "Inter"  !important;
  font-weight: bold;
  transition: all 0.3s ease  !important;
  text-transform: none  !important;
  font-weight: 300  !important;
  margin-top: 2rem  !important;
}

.styles_paragrafo__FRIbB{
  margin-bottom: .5rem;
}

.styles_btnModal__J-bZw{
  background: #18316e !important;
  margin-top: 1rem !important;
  &:hover{
    background: #0f2047 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CadastrarCnpj/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  color: #0f2047;\n  font-family: \"Inter\";\n  font-weight: 500;\n  text-align: center;\n  font-size: 1rem;\n}\n\n.separador {\n  margin-top: 1rem;\n  width: 100%;\n  max-width: 75vw;\n}\n\n.botoes{\n  align-items: flex-end;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.switch{\n  align-items: center;\n  display: flex;\n  gap: .2rem;\n  /* justify-content: space-between; */\n}\n\n.botaoTentar{\n  border:1px solid #18316e !important;\n  color: #18316e !important;\n  margin-right: 1rem !important;\n  margin-top: 2rem  !important;\n  text-transform: none  !important;\n}\n\n.containerBotao{\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.botaoProsseguir {\n  align-self: self-end;\n  background-color: #18316e !important;\n  color: white !important;\n  font-family: \"Inter\"  !important;\n  transition: all 0.3s ease  !important;\n  text-transform: none  !important;\n  font-weight: 300  !important;\n  margin-top: 2rem  !important;\n}\n\n.botaoFechar {\n  align-self: self-start;\n  background-color: #fff !important;\n  border: 1px solid #18316e;\n  color: #18316e !important;\n  font-family: \"Inter\"  !important;\n  font-weight: bold;\n  transition: all 0.3s ease  !important;\n  text-transform: none  !important;\n  font-weight: 300  !important;\n  margin-top: 2rem  !important;\n}\n\n.paragrafo{\n  margin-bottom: .5rem;\n}\n\n.btnModal{\n  background: #18316e !important;\n  margin-top: 1rem !important;\n  &:hover{\n    background: #0f2047 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `styles_main__RqlRW`,
	"title": `styles_title__NK1ji`,
	"separador": `styles_separador__5sS6U`,
	"botoes": `styles_botoes__cKl9H`,
	"switch": `styles_switch__wvlSc`,
	"botaoTentar": `styles_botaoTentar__pmwKQ`,
	"containerBotao": `styles_containerBotao__lt20e`,
	"botaoProsseguir": `styles_botaoProsseguir__mFtn9`,
	"botaoFechar": `styles_botaoFechar__IP9IE`,
	"paragrafo": `styles_paragrafo__FRIbB`,
	"btnModal": `styles_btnModal__J-bZw`
};
export default ___CSS_LOADER_EXPORT___;
